import React from "react";
import { INSTA_1 as Image1, INSTA_2 as Image2, INSTA_3 as Image3, INSTA_4 as Image4 } from "../cloudinary";
import { ReactSVG } from "react-svg";

import InstaLogo from "../Assets/ImageSection/Instagram/InstaLogo.svg";
const InstaSectionMob = () => {
  return (
    <div className="mx-6  lg:my-[100px]">
      <div className="  ">
        <div className="flex justify-center items-center mb-20">
          <a
            href="https://instagram.com/borjacafe"
            target="_blank"
            rel="noreferrer"
            className="flex items-center justify-end mb-4 bH1"
          >
            @borjacafe
            <ReactSVG src={InstaLogo} className="ml-2" />
          </a>
        </div>

        <div className="flex justify-end items-center ">
          <img src={Image2} width={200} height={200} alt="" />
        </div>

        {/* <div className="flex justify-start items-center my-8">
          <img src={Image5} width={200} height={200} />
        </div> */}
        {/* Image 4 - Centered */}
        <div className="flex justify-start items-center my-8">
          <img src={Image4} width={200} height={200} alt="" />
        </div>

        {/* Image 5 - Aligned Right */}
        <div className="flex justify-end items-center my-8 ">
          <img src={Image1} width={200} height={200} alt="" />
        </div>

        {/* Image 6 - Centered */}
        <div className="flex justify-start items-center ">
          <img src={Image3} width={200} height={200} alt="" />
        </div>
      </div>
    </div>
  );
};

export default InstaSectionMob;
